import {Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'ordinal'})
export class OrdinalPipe implements PipeTransform {
    transform(value: Date): string {
        return moment(value).utc().format('Do');
    }
}
